// X1 (agent-experience V1) — THE shared interaction-resolution rule.
//
// An interaction (approval card / ask_user) is RESOLVED only when a durable TOOL_CALL_RESULT event
// carries its interaction_id at the TOP LEVEL of the payload (the post-approve resume result —
// Sessions::Resume#tool_result_payload puts `interaction_id` beside `toolCallId`/`content`). The
// propose tool's OWN result does NOT resolve it: that result carries the id only INSIDE a
// stringified content field, never at payload top level.
//
// This rule is LOAD-BEARING and shared by three surfaces (Items A, B, G) plus the chat timeline:
//   • A — the "awaiting your approval" state clears on the resolution result
//   • B — the approval card flips read-only once resolved
//   • G — the panel's pending-action slot collapses once resolved
// Import from HERE; do not re-derive (verbatim copies drift — master plan X1).

/** The set of interaction_ids that have a durable resolution in `durableEvents`. */
export function resolvedInteractionIdSet(durableEvents = []) {
  const resolved = new Set()
  for (const e of durableEvents) {
    if (e && e.type === "TOOL_CALL_RESULT" && e.payload && e.payload.interaction_id) {
      resolved.add(e.payload.interaction_id)
    }
  }
  return resolved
}

/** Whether ONE interaction id has a durable resolution. Null/blank ids are never resolved. */
export function isInteractionResolved(durableEvents, interactionId) {
  if (interactionId == null || interactionId === "") return false
  return resolvedInteractionIdSet(durableEvents).has(interactionId)
}
